<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useApi } from '@/utils/axios'
import { USUARIO_ROTAS } from '@/utils/apiRoutes'

const countdown = ref(30)
let updateInterval = null
const usuariosOnline = ref([])
const loading = ref(false)
const error = ref(null)

const fetchUsuariosOnline = async () => {
  loading.value = true
  error.value = null
  try {
    const data = await useApi(USUARIO_ROTAS.USUARIOS_LOGADOS).fetch()
    usuariosOnline.value = Array.isArray(data) ? data : []
  } catch (err) {
    error.value = err?.message || 'Erro ao carregar usuários online'
  } finally {
    loading.value = false
  }
}

const startCountdown = () => {
  updateInterval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      countdown.value = 30
      fetchUsuariosOnline()
    }
  }, 1000)
}

const stopCountdown = () => {
  if (updateInterval) {
    clearInterval(updateInterval)
    updateInterval = null
  }
}

const forceUpdate = () => {
  countdown.value = 30
  fetchUsuariosOnline()
}

onMounted(() => {
  fetchUsuariosOnline()
  startCountdown()
})

onUnmounted(() => {
  stopCountdown()
})

</script>

<template>
  <div>
    <v-row>
      <v-col cols="12" class="d-flex align-center">
        <h1 class="text-h4">Usuários Online</h1>
        <v-chip size="small" color="info" class="ml-4" style="margin-top: -25px !important;">
          <v-icon start size="small">mdi-refresh</v-icon>
          Atualização em {{ countdown }}s
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="forceUpdate" size="small">
          Atualizar Agora
        </v-btn>
      </v-col>
    </v-row>

    <v-alert v-if="error" type="error" closable class="mb-4">
      {{ error }}
    </v-alert>

    <!-- <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>-->

    <v-data-table
      :headers="[
        { title: 'Status', key: 'status' },
        { title: 'Nome', key: 'nome' },
        { title: 'Última Atualização', key: 'ultima_atualizacao' }
      ]"
      :items="usuariosOnline"
      item-key="id"
      class="custom-table"
    >
      <template #item.status>
        <v-icon color="success" size="small">mdi-circle</v-icon>
        Online
      </template>
      
      <template #item.ultima_atualizacao="{ value }">
        {{ new Date((value || '').replace(' ', 'T')).toLocaleString('pt-BR') }}
      </template>
    </v-data-table>
  </div>
</template>